import { useQuery } from '@tanstack/react-query';

import { userStore } from '~/stores';

const HOUR = 60 * 60 * 1000;

/**
 * The delivery-zones query, as one object both callers share.
 *
 * Zones rarely change, so they are cached for an hour across modal opens. The
 * in-store QR link prefetches the same entry, and key, staleTime and gcTime
 * have to agree for that to be one fetch rather than two — copies in two files
 * disagreed about how long the entry survives with no observers.
 */
export const deliveryZonesQuery = () => ({
  queryKey: ['delivery-zones'] as const,
  queryFn: () => userStore.getDeliveryZones(),
  staleTime: HOUR,
  gcTime: HOUR,
});

/**
 * Cached delivery zones for the address modals.
 *
 * `enabled` lets a caller that only needs zones on some tenants skip the
 * request entirely. The key is the shared one either way, so a later enabled
 * caller — or the QR-link prefetch — still reuses whatever was fetched.
 */
export function useDeliveryZones(enabled = true) {
  return useQuery({ ...deliveryZonesQuery(), enabled });
}
